
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { CardResultMixin } from './cardresultmixin'

@Options({})
export default class DCardResultView extends Mixins(CardResultMixin) {}
